import Workout from "./workout";

export default Workout;